import { SxProps, Theme } from '@mui/material';

export const panelStyles: SxProps<Theme> = {
    maxWidth: 560,
    mx: 'auto',
    py: 4,
    textAlign: 'center',
};

export const iconStyles: SxProps<Theme> = {
    fontSize: 56,
    color: 'primary.main',
    mb: 2,
};

export const titleStyles: SxProps<Theme> = {
    fontWeight: 700,
    mb: 2,
};

export const bodyStyles: SxProps<Theme> = {
    color: 'text.secondary',
    mb: 3,
};

export const actionsStyles: SxProps<Theme> = {
    display: 'flex',
    gap: 2,
    justifyContent: 'center',
    flexWrap: 'wrap',
};
